<div class="card">
  <h4>
    <strong> Shipment </strong>
  </h4>
  <hr />
  <div *ngIf="isContentVisible">
    <!-- <div class="flex flex-wrap gap-0">
            <div class="flex flex-wrap gap-1 mb-3">
                <div class="flex-auto">
                    <label for="integer" class="font-bold block mb-2">Company Code</label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="companyCode" placeholder="Company Code"
                            pKeyFilter="alpha" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="number" class="font-bold block mb-2">Plant</label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="plant" placeholder="Plant " pKeyFilter="Plant"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="money" class="font-bold block mb-2"> Doc.Type </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docType" placeholder="Doc.Type"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="money" class="font-bold block mb-2"> Doc.Cat </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docCat" placeholder="Doc.Cat"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="hex" class="font-bold block mb-2"> PO/Agreement No </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="poAgreementNo" placeholder="PO/Agreement No"
                            pKeyFilter="PO/Agreement No" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphabetic" class="font-bold block mb-2"> Vendor Code </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="vendorCode" placeholder="Vendor Code"
                            pKeyFilter="Vendor Code" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphabetic" class="font-bold block mb-2"> Shipment No </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="shipmentNo" placeholder="Shipment No"
                            pKeyFilter="Vendor Code" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="hex" class="font-bold block mb-2"> Document Date </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [iconDisplay]="'input'" [(ngModel)]="documentDate" [showIcon]="true"
                            placeholder="Document Date" class="custom-calendar-filter"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphanumeric" class="font-bold block mb-2"> Shipment from </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="shipmentDeliverFrom" placeholder="Shipment from"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphanumeric" class="font-bold block mb-2"> Shipment To </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="shipmentDeliverTo" placeholder="Shipment To"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2 pl-5 mt-2">
                <div class="flex-auto">
                    <p-button class="flex justify-content-end" icon="pi pi-search" (click)="onFilterShipmentData()"
                        label="search" pAutoFocus [autofocus]="true"></p-button>
                </div>
            </div>
        </div> -->

    <!-- <div class="col-12 md:col-12">
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Company Code</label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="companyCode"
                            pKeyFilter="alpha" class="w-full text-sm py-1" />
                    </div>

                </div>
                <div class="field col">
                    <label>Plant</label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="plant"  pKeyFilter="Plant"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Doc.Type </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docType"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Doc.Cat </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docCat"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> PO/Agreement No </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="poAgreementNo"
                            pKeyFilter="PO/Agreement No" class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Vendor Code </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="vendorCode"
                            pKeyFilter="Vendor Code" class="w-full text-sm py-1" />
                    </div>
                </div>
            </div>

            <div class="p-formgrid grid">
                <div class="field col">
                    <label> Shipment No </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="shipmentNo"
                            pKeyFilter="Vendor Code" class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Document Date </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [iconDisplay]="'input'" [(ngModel)]="documentDate" [showIcon]="true"
                             class="custom-calendar-filter"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
                <div class="field col">
                    <label> Shipment from </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="shipmentDeliverFrom"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> Shipment To </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="shipmentDeliverTo" placeholder="Shipment To"
                            class="w-full text-sm py-1" />
                    </div>
                </div>
                <div class="field col">
                    <label> </label>
                    <p-button class="flex justify-content-end" icon="pi pi-search" (click)="onFilterShipmentData()"
                        label="search" pAutoFocus [autofocus]="true" [ngStyle]="{'height.px': '30'}"></p-button>
                </div>
                <div class="field col">
                </div>
            </div>
        </div> -->
  </div>

  <div style="margin-bottom: 10px"></div>
  <!-- <div class="content-toggle-aero">
        <button (click)="toggleContentVisibility()" class="content-toggle-button">
            <i class="pi" [ngClass]="isContentVisible ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
        </button>
        <div class="line"></div>
    </div> -->
  <div style="margin-bottom: 10px"></div>

  <p-treeTable
    #tt
    [value]="mappedData"
    styleClass="p-treetable-gridlines"
    [columns]="cols"
    [tableStyle]="{ 'min-width': '150rem','min-height':'10px' }"
    [scrollable]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 4rem; white-space: nowrap">Action</th>
        <th>Position</th>
        <th>Shipment Status</th>
        <th>Shipment No</th>
        <th>Invoice</th>
        <th>Packing Type</th>
        <th>Total Number</th>
        <th>Net Weight</th>
        <th>Gross Weight</th>
        <th>Driver</th>
        <th>vehicle</th>
        <th>Route</th>
        <th>Dispatch Date</th>
        <th>Expected Delivery Date</th>

      </tr>
      <!-- <tr>
                <th class="text-center">Plant</th>
                <th class="text-center">PO/Agreement No</th>
                <th class="text-center">Delivery Date</th>
                <th class="text-center">Name</th>
                <th class="text-center">Item No</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">Batch No</th>
                <th class="text-center">Batch Quantity</th>
                <th class="text-center">UOM</th>
                <th class="text-center">Material Code</th>
            </tr> -->
      <tr>
        <th></th>
        <th *ngFor="let col of cols">
          <ng-container *ngIf="col.field === 'expected_delivery_date' || col.field === 'dispatch_date' || col.field === 'disDate'; else textInput">
            <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
          </ng-container>
          <ng-template #textInput>
            <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
          </ng-template>
          <!-- <input
            pInputText
            type="text"
            placeholder="Search..."
            style="font-size: smaller"
            (input)="onInputChange($event, col.field)"
          />
        </th> -->
        <!-- <th></th> -->
      </tr>
    </ng-template>
    <!-- <ng-template pTemplate="caption">
      <div class="flex justify-content-end align-items-center">
        <div class="p-input-icon-left">
          <i class="pi pi-search" style="font-size: 12px"></i>
          <input
            type="text"
            class="global-search"
            pInputText
            placeholder="Global Search"
            (input)="onGlobalSearch($event)"
          />
        </div>
      </div>
    </ng-template> -->
    <ng-template
      pTemplate="body"
      let-rowNode
      let-rowData="rowData"
      let-columns="columns"
    >
      <tr [ttRow]="rowNode">
        <td style="width: 4rem; white-space: nowrap">
          <p-button
            *ngIf="rowNode.node.children && rowNode.node.children.length > 0"
            tooltipPosition="top"
            icon="pi pi-eye"
            (click)="onClickASN(rowNode)"
            [rounded]="true"
            [style]="{ 'margin-right': '.5em' }"
          ></p-button>
        </td>
        <td *ngFor="let col of columns; let i = index; let last = last">
          <div class="row">
            <!-- <div class="column">
                            <p-button *ngIf="i === 0 && rowNode.node.children && rowNode.node.children.length > 0"
                                tooltipPosition="top" icon="pi pi-eye" (click)="onClickASN(rowNode)" [rounded]="true"
                                [style]="{ 'margin-right': '.5em' }"></p-button>
                        </div> -->
            <div>
              <!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler> -->
            </div>
            <!-- <div>
                            {{ rowData[col.field] }}
                        </div> -->
                <div [ngSwitch]="col.field">
                    <div *ngSwitchCase = "'position'">
                        <app-delivery-bar
                            [dispatchDateTime]="rowData.dispatch_date"
                            [expectedDeliveryDateTime]="rowData.expected_delivery_date"
                        ></app-delivery-bar>
                        <!-- <app-delivery-bar

                        ></app-delivery-bar> -->
                    </div>
                      <div *ngSwitchCase="'pono'">
                        <span
                          class="custom-tag"
                          [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))"
                        >
                          {{ rowData[col.field] }}
                        </span>
                      </div>

                      <div *ngSwitchCase="'dispatch_date'">
                        <span>
                          {{ rowData[col.field] | date:'dd.MM.yy HH:mm:ss' }}
                        </span>
                      </div>

                      <!-- For Expected Delivery Date -->
                      <div *ngSwitchCase="'expected_delivery_date'">
                        <span>
                          {{ rowData[col.field] | date:'dd.MM.yy HH:mm:ss' }}
                        </span>
                      </div>

                      <div *ngSwitchDefault>
                        {{ rowData[col.field] }}
                      </div>
                </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>

  <div>
    <p-paginator
    [rows]="limit"
    [first]="(currentPage - 1) * limit"
    [totalRecords]="totalRecords"
    (onPageChange)="onPageChange($event)"
    [rowsPerPageOptions]="[10, 20,30,50,100]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [showCurrentPageReport]="true"
     />
</div>
</div>

<p-sidebar
  [(visible)]="sidebarVisible2"
  position="right"
  [style]="{ width: '65%' }"
>
  <div class="row">
    <div class="column">
      <h5>
        <strong>{{ selectedASNNO }}</strong>
      </h5>
    </div>
    <div class="column">
      <div class="button-container">
        <!-- <button
        type="button"
        pButton
        pRipple
        (click)="tokenCreateDialog()"
        class="p-button-plain mr-2"
        tooltipPosition="bottom"
        label="Create Token"
      ></button> -->
        <button
          type="button"
          pButton
          pRipple
          (click)="showDialog2()"
          class="p-button-plain mr-2"
          tooltipPosition="bottom"
          label="Attach Document"
        ></button>
        <!-- <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="downloadShipmentExcel()"
                    class="p-button-success mr-2" pTooltip="XLS ASN" tooltipPosition="bottom"></button> -->
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-file-excel"
          (click)="exportExcel()"
          class="p-button-success mr-2"
          pTooltip="XLS"
          tooltipPosition="bottom"
        ></button>
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-file-pdf"
          (click)="generatePdfWithQRCode()"
          class="p-button-info mr-2"
          pTooltip="PDF"
          tooltipPosition="bottom"
        ></button>
      </div>
    </div>
  </div>
  <br />
  <p-table
    #dt
    [value]="selectedASN"
    styleClass="p-datatable-sm"
    selectionMode="multiple"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of cols2">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>{{ rowData.invoice }}</td>
        <td>{{ rowData.packing_type }}</td>
        <td>{{ rowData.total_number }}</td>
        <td>{{ rowData.total_net_weight }}</td>
        <td>{{ rowData.total_gross_weight }}</td>
        <td>{{ rowData.driver }}</td>
        <td>{{ rowData.vehicle }}</td>
        <td>{{ rowData.deliver_from }}</td>
        <td>{{ rowData.deliver_to }}</td>
        <td>{{ rowData.route }}</td>
        <td>{{ rowData.expected_delivery_date | date : "dd.MM.yyyy" }}</td>
      </tr>
    </ng-template>
  </p-table>
  <h5><strong>Schedule Deliveries</strong></h5>
  <br />
  <p-table
    #dt
    [value]="selectedASNScheduleDeliveries"
    styleClass="p-datatable-sm"
    selectionMode="multiple"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of cols3">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>{{ rowData.shipmentno }}</td>
        <td>{{ rowData.plant }}</td>
        <td>{{ rowData.pono }}</td>
        <td>{{ rowData.shipmentdate }}</td>
        <td>{{ rowData.vcode }}</td>
        <td>{{ rowData.name }}</td>
        <td>{{ rowData.batchNo }}</td>
        <td>{{ rowData.quantity }}</td>
        <td>{{ rowData.status }}</td>
        <td>{{ rowData.material_code }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-sidebar>

<p-dialog
  header="Attach Documents"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '35rem' }"
>
  <span class=" p-text-secondary block mb-5">Upload Your Documents.</span>
  <div class="grid">
    <div class=" field col flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">Invoice</label>
      <p-fileUpload
        mode="basic"
        name="invoice"
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
        (onSelect)="onInvoiceUpload($event)"
        chooseLabel=""
        *ngIf="!invoiceFile"
      ></p-fileUpload>
      <div *ngIf="invoiceFile">
        <span>{{ invoiceFile.name }}</span>
        <button
          type="button"
          pButton
          icon="pi pi-times"
          class="p-fileupload-close p-button-rounded p-button-success"
          (click)="cancelInvoiceUpload()"
        ></button>
      </div>
    </div>
    <div class="field col">
      <button pButton class="btn btn-primary" style="max-width: min-content;" *ngIf="invoiceFileUrl"
        (click)="downloadFile(invoiceFileUrl, 'invoice_document')">
        <i class="pi pi-download"></i>
      </button>
    </div>
  </div>
  <div class="grid">
    <div class="field col flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">E Way Bill</label>
      <p-fileUpload
        mode="basic"
        name="ewaybill"
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
        (onSelect)="onEWayBillUpload($event)"
        chooseLabel=""
        *ngIf="!eWayBillFile"
      ></p-fileUpload>
      <div *ngIf="eWayBillFile">
        <span>{{ eWayBillFile.name }}</span>
        <button
          type="button"
          pButton
          icon="pi pi-times"
          class="p-fileupload-close p-button-rounded p-button-success"
          (click)="cancelEWayBillUpload()"
        ></button>
      </div>
    </div>
    <div class="field col">
      <button pButton class="btn btn-primary" style="max-width: min-content;" *ngIf="eWayBillFileUrl"
        (click)="downloadFile(eWayBillFileUrl, 'e_way_bill_document')">
        <i class="pi pi-download"></i>
      </button>
    </div>
  </div>
  <div class="grid">
    <div class="field col flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">IRN</label>
      <p-fileUpload
        mode="basic"
        name="irn"
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
        (onSelect)="onIRNBillUpload($event)"
        chooseLabel=""
        *ngIf="!iRNBillFile"
      ></p-fileUpload>
      <div *ngIf="iRNBillFile">
        <span>{{ iRNBillFile.name }}</span>
        <button
          type="button"
          pButton
          icon="pi pi-times"
          class="p-fileupload-close p-button-rounded p-button-success"
          (click)="cancelIRNUpload()"
        ></button>
      </div>
    </div>
    <div class="field col">
      <button pButton class="btn btn-primary" style="max-width: min-content;" *ngIf="iRNBillFileUrl"
        (click)="downloadFile(iRNBillFileUrl, 'irn_document')">
        <i class="pi pi-download"></i>
      </button>
    </div>
  </div>
  <div class="flex justify-content-end gap-2">
    <p-button label="Cancel" (click)="visible = false" />
    <p-button label="Save" (click)="onUplosdDocuments()" />
  </div>
</p-dialog>
<p-toast></p-toast>

<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
